import { X } from "lucide-react";

export interface ActiveChip {
  key: string;
  label: string;
  onRemove: () => void;
  testId: string;
}

interface Props {
  chips: ActiveChip[];
  onClearAll: () => void;
}

export function ActiveFilterChips({ chips, onClearAll }: Props) {
  if (chips.length === 0) return null;
  return (
    <div
      className="flex flex-wrap items-center gap-1.5 mb-3"
      data-testid="active-filter-chips"
    >
      <span className="text-xs text-muted-foreground mr-1">Filters:</span>
      {chips.map((chip) => (
        <button
          key={chip.key}
          type="button"
          onClick={chip.onRemove}
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-muted hover:bg-muted/70 text-xs text-foreground border border-border transition-colors"
          data-testid={chip.testId}
        >
          <span>{chip.label}</span>
          <X className="h-3 w-3 text-muted-foreground" aria-hidden />
          <span className="sr-only">Remove filter</span>
        </button>
      ))}
      <button
        type="button"
        onClick={onClearAll}
        className="text-xs text-primary hover:underline ml-1"
        data-testid="button-clear-all-filters"
      >
        Clear all
      </button>
    </div>
  );
}
